<template lang="pug">
  component(:is="resourceName" :model="resource" v-if="resource")
</template>

<script>
import Slide from '@/models/Slide';
import Presentation from '@/models/Presentation';
import SlideInfo from '@/components/ResourceInfo/SlideInfo';
import PresentationInfo from '@/components/ResourceInfo/PresentationInfo';

export default {
  name: 'resource-info',

  components: {
    SlideInfo,
    PresentationInfo,
  },

  props: {
    resourceType: String,
    resourceId: Number,
  },

  data() {
    return {
      resource: null,
    };
  },

  computed: {
    resourceName() {
      if (this.resourceType === 'slides') {
        return 'slide-info';
      }

      if (this.resourceType === 'presentations') {
        return 'presentation-info';
      }

      return null;
    },
  },

  async created() {
    if (this.resourceType === 'slides') {
      const slide = new Slide();

      await slide.$find(this.resourceId);

      this.resource = slide;
    }

    if (this.resourceType === 'presentations') {
      const presentation = new Presentation();

      await presentation.$find(this.resourceId);

      this.resource = presentation;
    }
  },
};
</script>
